import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

const defaultProps = {
  className: ''
};

export default class PageBody extends Component {
  render() {
    const classes = this.props.className;

    return (
      <div id="page-body" className={classes}>
        {this.props.children}
      </div>
    );
  }
}

PageBody.propTypes = propTypes;
PageBody.defaultProps = defaultProps;
